<template>
  <Modal ref="modal" title="Informações da aula" @cancel="close">
    <div class="loading" v-if="!loaded">
      <LoadingSpinner />
    </div>

    <Tabs
      class="modal-container"
      :options="[
        'Dados Básicos',
        'Alertas DETRAN',
        'Avaliação',
        'Infrações',
        'Comportamento',
        'Fotos',
      ]"
      :highlightRed="highlights"
      @handle:change="onTabChanged"
      v-else
    >
      <div slot="Dados Básicos">
        <div class="dados-basicos-container">
          <div class="box">
            <div class="info-row">
              <div class="info-col">
                <strong>Aluno:</strong>
                <span>{{ aula.nomeAluno }} - {{ aula.cpfAluno }}</span>
              </div>

              <div class="info-col">
                <strong>Instrutor:</strong>
                <span>{{ aula.nomeInstrutor }} - {{ aula.cpfInstrutor }}</span>
              </div>

              <div class="info-col">
                <strong>Categoria:</strong>
                <span>{{ aula.categoria_cnh || '-' }}</span>
              </div>

              <div class="info-col">
                <strong>Tipo:</strong>
                <span>{{ aula.tipo_aula || '-' }}</span>
              </div>

              <div class="info-col">
                <strong>Conteúdo:</strong>
                <span>{{ anotacao.edu_content || '-' }}</span>
              </div>
            </div>

            <div class="info-row">
              <div class="info-col">
                <strong>Modelo:</strong>
                <span>{{ aula.modelo || '-' }}</span>
              </div>

              <div class="info-col">
                <strong>Marca:</strong>
                <span>{{ aula.marca || '-' }}</span>
              </div>

              <div class="info-col">
                <strong>Cor:</strong>
                <span>{{ aula.cor || '-' }}</span>
              </div>

              <div class="info-col">
                <strong>Ano:</strong>
                <span>{{ aula.ano_modelo || '-' }}</span>
              </div>

              <div class="info-col">
                <strong>Placa:</strong>
                <span>{{ aula.placa || '-' }}</span>
              </div>
            </div>
          </div>

          <div class="box">
            <div class="info-row">
              <div class="info-col">
                <strong>Inicio da Aula (Previsto):</strong>
                <span>{{ utils.formatDate(aula.data_aula) }}</span>
              </div>

              <div class="info-col">
                <strong>Duração (Previsto):</strong>
                <span>50 Minutos</span>
              </div>

              <div class="info-col">
                <strong>Fim da aula (Previsto):</strong>
                <span>
                  {{
                    utils.formatDate(
                      aula.data_aula.split(' ')[0] +
                        ' ' +
                        new Date(
                          new Date(aula.data_aula).getTime() + 50 * 60000
                        ).toLocaleTimeString()
                    )
                  }}</span
                >
              </div>
            </div>

            <div class="info-row">
              <div class="info-col">
                <strong>Inicio da Aula (Real):</strong>
                <span>{{ utils.formatDate(anotacao.begin_time) }}</span>
              </div>

              <div class="info-col">
                <strong>Duração (Real):</strong>
                <span>{{ periodo }}</span>
              </div>

              <div class="info-col">
                <strong>Fim da aula (Real):</strong>
                <span>
                  {{ utils.formatDate(anotacao.finish_time) }}
                </span>
              </div>
            </div>
          </div>

          <div class="box">
            <div class="info-row">
              <div class="info-col">
                <strong>Quilometragem inicial:</strong>
                <span>{{ anotacao.hodo_start }} Km</span>
              </div>

              <div class="info-col">
                <strong>Quilometragem final:</strong>
                <span>{{ anotacao.hodo_end }} Km</span>
              </div>

              <div class="info-col">
                <strong>Distância percorrida (Hodômetro):</strong>
                <span> {{ anotacao.hodo_end - anotacao.hodo_start - 1 }} Km </span>
              </div>
            </div>

            <div class="info-row">
              <div class="info-col">
                <strong>Distância percorrida (GPS):</strong>
                <span id="distance_gps"></span>
              </div>

              <div class="info-col">
                <strong>Distância Inicial da Autoescola:</strong>
                <span v-if="latIni && latIni.distancia_inicio">{{
                  Math.trunc(latIni.distancia_inicio * 1000) + ' ' + 'Metros'
                }}</span>
                <span v-else>-</span>
              </div>

              <div class="info-col">
                <strong>Distância Final da Autoescola:</strong>
                <template v-if="latIni && latIni.distancia_fim">
                  <span v-if="Math.trunc(latIni.distancia_fim * 1000) > 500">
                    {{ Math.trunc(latIni.distancia_fim * 1000) }} Metros
                  </span>
                  <span v-else>{{ Math.trunc(latIni.distancia_fim * 1000) }} Metros</span>
                </template>

                <span v-else>-</span>
              </div>
            </div>
          </div>

          <div class="box">
            <div class="info-row">
              <div class="info-col" v-if="anotacao.finish_reason">
                <strong>Aula não concluída:</strong>
                <span>{{ anotacao.finish_reason }}</span>
              </div>

              <div class="info-col">
                <strong>Aula dupla:</strong>
                <span>{{ aula.dupla ? 'Sim' : 'Não' }}</span>
              </div>
            </div>
          </div>

          <Button
            v-if="!anotacao.processada"
            class="actions"
            @handle:click="processarAnotacao"
            text="Processar aula"
            color="primary"
            :disabled="loadingProcess"
          />
        </div>
      </div>

      <div slot="Alertas DETRAN">
        <Table :headers="['Instrutor', 'Veículo', 'Data e Hora', 'Alerta']">
          <tr v-if="!alertasDetran.length">
            <td colspan="4">
              <div class="text-center">Sem resultados</div>
            </td>
          </tr>
          <tr v-for="alert in alertasDetran" :key="alert.id">
            <td>{{ alert.nomeInstrutor }}</td>
            <td>{{ alert.placa }}</td>
            <td>{{ alert.data_aula | DateBRFilter }}</td>
            <td v-if="alert.alerta_total">{{ alert.alerta }} - <strong>Tempo total parado: {{ alert.alerta_total }}</strong></td>
            <td v-else>{{ alert.alerta }}</td>
          </tr>
        </Table>
      </div>

      <div slot="Avaliação" class="avaliacao-container">
        <div class="empty" v-if="!anotacao.avaliacoes.length">
          <span>Sem avaliações</span>
        </div>

        <div
          v-else
          v-for="avaliacao in anotacao.avaliacoes"
          :key="avaliacao.avaliacao_id"
          class="avaliacao"
        >
          <ClipboardListOutline :size="24" />

          <span>{{ avaliacao.descricao }}</span>
        </div>
      </div>

      <div slot="Infrações" class="infracao-container">
        <div class="empty" v-if="!anotacao.infracoes.length">
          <span>Sem infrações</span>
        </div>

        <div
          v-else
          v-for="infracao in anotacao.infracoes"
          :key="infracao.cod_infracao"
          class="infracao"
        >
          <AlertOutline :size="24" />

          <span>{{ infracao.detalhe }}</span>
        </div>
      </div>

      <div slot="Comportamento" class="comportamento-container">
        <div class="empty" v-if="!anotacao.comportamentos.length">
          <span>Sem comportamentos</span>
        </div>

        <div
          v-else
          v-for="comportamento in anotacao.comportamentos"
          :key="comportamento.id_comportamento_aluno"
          class="comportamento"
        >
          <Brain :size="24" />

          <span>{{ comportamento.descricao }}</span>
        </div>
      </div>

      <div slot="Fotos">
        <div class="photos-container">
          <div class="photos-header">
            <span>Total de fotos</span>
            <span>{{ anotacao.fotos.length }}</span>
          </div>

          <div class="photos-content">
            <div class="current-container">
              <img ref="currentPhoto" alt="Foto atual" />

              <div class="actions">
                <Button
                  @handle:click="setImageStatus(2)"
                  color="danger"
                  title="Nenhum aluno detectado"
                  :disabled="validateLoading"
                >
                  <AccountQuestionOutline :size="24" />
                </Button>

                <Button
                  @handle:click="setImageStatus(1)"
                  color="danger"
                  title="Sem imagem"
                  :disabled="validateLoading"
                >
                  <EyeOffOutline :size="24" />
                </Button>

                <Button
                  @handle:click="setImageStatus(3)"
                  color="secondary"
                  title="imagem com erro"
                  :disabled="validateLoading"
                >
                  <AlertOutline :size="24" />
                </Button>

                <Button
                  @handle:click="setImageStatus(4)"
                  color="success"
                  title="Imagem ok"
                  :disabled="validateLoading"
                >
                  <Check :size="24" />
                </Button>
              </div>
            </div>

            <div class="photos-container">
              <div class="photos-list">
                <img
                  v-for="(foto, fotoIndex) in anotacao.fotos"
                  :key="'foto_' + foto.id_foto_pratica"
                  @click="checkImage(fotoIndex)"
                  :id="'status_' + foto.id_foto_pratica"
                  :src="'data:image/' + foto.ext + ';base64, ' + foto.foto"
                  :class="{
                    red: foto.id_status === 1 || foto.id_status === 2,
                    yellow: foto.id_status === 3,
                    green: foto.id_status === 4,
                  }"
                  alt="Foto da aula"
                />
              </div>

              <Button
                type="button"
                @handle:click="validateAll"
                text="Validar todas"
                color="primary"
                :disabled="validateLoading"
              >
                <Check :size="18" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Tabs>
  </Modal>
</template>

<script>
import Button from 'core/Button'
import IconButton from 'core/IconButton'
import LoadingSpinner from 'core/LoadingSpinner'
import Modal from 'core/Modal'
import Table from 'core/Table'
import Tabs from 'core/Tabs'

import AccountQuestionOutline from 'icons/AccountQuestionOutline'
import AlertOutline from 'icons/AlertOutline'
import Brain from 'icons/Brain'
import Check from 'icons/Check'
import ClipboardListOutline from 'icons/ClipboardListOutline'
import EyeOffOutline from 'icons/EyeOffOutline'

import utils from '../../services/utils'
import GoogleMap from '../google/GoogleMap'

export default {
  components: {
    Modal,
    Tabs,
    LoadingSpinner,
    Button,
    Table,
    IconButton,

    Check,
    ClipboardListOutline,
    Brain,
    AlertOutline,
    AccountQuestionOutline,
    EyeOffOutline,

    GoogleMap,
  },
  props: {
    schema: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      aulaId: null,
      utils: utils,
      aula: null,
      anotacao: null,
      currentPhotoId: null,
      latIni: null,
      periodo: '',
      loaded: false,
      alertasDetran: [],
      loadingProcess: false,
      validateLoading: false,
    }
  },
  watch: {
    alertasDetran(newVal) {
      this.highlights =
        newVal.length && this.aula.status === 'Aula bloqueada por alerta' ? ['Alertas DETRAN'] : []
    },
  },
  methods: {
    async open(aulaId) {
      this.aulaId = aulaId
      this.$refs.modal.open()

      await this.details(aulaId)
    },
    close() {
      this.loaded = false
    },
    async details(aulaId) {
      await this.$http
        .get(`${process.env.VUE_APP_URL_API}/aulas/praticas/realizada/${aulaId}`)
        .then(async ({ body }) => {
          this.aula = body.dados
          this.anotacao = body.dados.anotacao

          await this.getAlertaDetails(body.dados.anotacao.id_anotacao_pratica)

          const periodo = this.formatTimeDifference(
            body.dados.anotacao.begin_time,
            body.dados.anotacao.finish_time
          )

          this.periodo = periodo

          await Promise.all([this.getConteudo(body.dados.anotacao), this.getPosicoes(body.dados)])

          this.checkImage(0)
        })
        .catch(err => {
          console.log(err)
          this.$refs.modal.close()

          this.$toasted.show('Erro ao buscar informações da aula.', {
            icon: 'fa-times',
            position: 'top-right',
            duration: 5000,
            fullWidth: false,
          })
        })
        .finally(() => {
          this.loaded = true
        })
    },
    async getAlertaDetails(id) {
      await this.$http
        .get(
          `${process.env.VUE_APP_URL_API_V2}/aulas/praticas/consultar/alerta/${this.schema}/${id}`
        )
        .then(({ body }) => {
          this.alertasDetran = body.dados
        })
        .catch(({ body }) => {
          this.$toasted.show(body.mensagem, {
            icon: 'fa-times',
            position: 'top-right',
            duration: 5000,
            fullWidth: false,
          })
        })
    },
    checkImage(index) {
      const photo = this.anotacao.fotos[index]

      const currentPhoto = this.$refs.currentPhoto

      if (currentPhoto) {
        currentPhoto.src = 'data:image/' + photo.ext + ';base64, ' + photo.foto

        currentPhoto.classList.remove('red', 'yellow', 'green', 'default')

        switch (photo.id_status) {
          case 1:
          case 2:
            currentPhoto.classList.add('red')
            break
          case 3:
            currentPhoto.classList.add('yellow')
            break
          case 4:
            currentPhoto.classList.add('green')
            break
          default:
            currentPhoto.classList.add('default')
            break
        }

        this.currentPhotoId = photo.id_foto_pratica
      }
    },
    formatTimeDifference(startTime, endTime) {
      const start = new Date(startTime)
      const end = new Date(endTime)

      const diffMs = Math.abs(end - start)
      const totalSeconds = Math.floor(diffMs / 1000)

      const hours = Math.floor(totalSeconds / 3600)
      const minutes = Math.floor((totalSeconds % 3600) / 60)
      const seconds = totalSeconds % 60

      const pad = num => String(num).padStart(2, '0')

      return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
    },
    async getConteudo(anotacao) {
      if (anotacao.edu_content) {
        this.$http
          .get(`${process.env.VUE_APP_URL_API}/planos/praticos/constante/${anotacao.edu_content}`)
          .then(response => {
            this.anotacao.edu_content = response.data
          })
          .catch(() => {
            this.anotacao.edu_content = '-'
          })
      } else {
        this.anotacao.edu_content = '-'
      }

      this.checkImage(0)
    },
    async getPosicoes(aula) {
      if (aula.anotacao.posicoes.length) {
        const params = {
          aluno: aula.id_aluno,
          lat: aula.anotacao.posicoes[0].lat,
          lon: aula.anotacao.posicoes[0].lon,
          latFim: aula.anotacao.posicoes[aula.anotacao.posicoes.length - 1].lat,
          lonFim: aula.anotacao.posicoes[aula.anotacao.posicoes.length - 1].lon,
        }

        this.$http
          .get(`${process.env.VUE_APP_URL_API}/aulas/praticas/distancia/aulapratica`, {
            params,
          })
          .then(response => {
            this.latIni = response.body.dados
          })
      }
    },
    async processarAnotacao() {
      this.loadingProcess = true

      await this.$http
        .get(
          `${process.env.VUE_APP_URL_API}/getran/atualizar/pratica/${this.anotacao.id_anotacao_pratica}`
        )
        .then(res => {
          this.$toasted.show('Processada com sucesso!', {
            icon: 'fa-times',
            position: 'top-right',
            duration: 5000,
            fullWidth: false,
          })

          this.$emit('refetch')

          this.close()
        })
        .catch(err => {
          this.$toasted.show(err.body.mensagem, {
            icon: 'fa-times',
            position: 'top-right',
            duration: 5000,
            fullWidth: false,
          })
        })
        .finally(() => {
          this.loadingProcess = false
        })
    },
    async validateAll() {
      this.validateLoading = true

      const fotos = this.anotacao.fotos.map(foto => foto.id_foto_pratica)

      await this.$http
        .post(`${process.env.VUE_APP_URL_API}/aulas/praticas/fotos/todas`, {
          fotos,
        })
        .then(async res => {
          await this.reload()
        })
        .catch(err => {
          console.log(err)
          this.$toasted.show(err.body.mensagem, {
            icon: 'fa-times',
            position: 'top-right',
            duration: 5000,
            fullWidth: false,
          })
        })
        .finally(() => {
          this.validateLoading = false
        })
    },
    async reload() {
      this.loaded = false

      await this.details(this.aulaId)
    },
    onTabChanged(tabName) {
      if (tabName === 'Fotos') {
        this.checkImage(0)
      }
    },
    async setImageStatus(type) {
      this.validateLoading = true

      await this.$http
        .get(`${process.env.VUE_APP_URL_API}/aulas/praticas/fotos/${this.currentPhotoId}/${type}`)
        .then(async res => {
          await this.reload()
        })
        .catch(err => {
          this.$toasted.show(err.body.mensagem, {
            icon: 'fa-times',
            position: 'top-right',
            duration: 5000,
            fullWidth: false,
          })
        })
        .finally(() => {
          this.validateLoading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.loading {
  width: 80vw;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-container {
  width: 80vw;

  .empty {
    font-weight: 600;
    color: #1c2d5a;
    text-align: center;
  }

  .dados-basicos-container {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    .box {
      padding: 0.75rem;
      border: 1px solid rgba(28, 45, 90, 0.5);
      border-radius: 10px;

      display: flex;
      flex-direction: column;
      gap: 1rem;
    }

    .info-row {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 1rem;
      flex-wrap: wrap;

      .info-col {
        flex: 1;
        display: flex;
        flex-direction: column;

        strong {
          font-weight: 600;
          font-size: 1rem;
          color: #1c2d5a;
        }

        span {
          font-size: 0.875rem;
        }
      }
    }

    .actions {
      display: flex;
      justify-content: center;
    }
  }

  .avaliacao-container,
  .comportamento-container,
  .infracao-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .avaliacao,
    .comportamento,
    .infracao {
      padding-bottom: 1rem;
      border-bottom: 1px solid rgba(128, 128, 128, 0.3);
      display: flex;
      align-items: center;
      gap: 1rem;

      span {
        font-weight: 600;
        color: #1c2d5a;
      }
    }
  }

  .photos-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .photos-header {
      display: flex;
      justify-content: space-between;

      border: 1px solid #1c2d5a;
      border-radius: 14px;
      padding: 0.5rem 2rem;

      > span {
        font-weight: 700;
        font-size: 0.875rem;
        color: #202224;
      }
    }

    .photos-content {
      display: flex;
      gap: 2rem;

      .current-container {
        display: flex;
        flex-direction: column;
        gap: 1rem;

        img {
          border-radius: 10px;
          width: 20rem;
          object-fit: cover;
        }

        .actions {
          display: flex;
          justify-content: space-between;
          gap: 1px;
        }
      }

      .photos-container {
        flex: 1;
        display: flex;
        flex-direction: column;

        .photos-list {
          max-height: 26rem;
          padding-right: 1rem;
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          overflow-y: auto;

          img {
            width: 6.25rem;
            border-radius: 10px;
            object-fit: cover;
            cursor: pointer;
          }
        }

        button {
          justify-content: center;
        }
      }

      .red {
        border: solid 2px rgb(255, 0, 0);
      }

      .yellow {
        border: solid 2px rgb(255, 251, 0);
      }

      .green {
        border: solid 2px rgb(9, 255, 0);
      }

      .default {
        border: solid 2px rgba(0, 0, 0, 0.13);
      }
    }
  }
}
</style>
